/**
 *  OKJP-国际-企业-基本信息
 */
import { FormType, FormErrorType } from '_common/components/Form/FormType';
import {
  checkJP,
  checkInt,
  checkJpName,
  checkEnName,
  checkJpPostcode,
  checkIfFullWidthEngAndNum,
  checkIfContainHalfWidthKatakanaOrSymbol,
} from '_common/utils/Check';
import { translate } from '_common/utils/language';

function getBase() {
  const template = {
    // 企业名称
    companyName: {
      formType: FormType.TEXT,
      title: translate('jp.company.companyName'),
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 50,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return (
              checkIfFullWidthEngAndNum(val) ||
              checkIfContainHalfWidthKatakanaOrSymbol(val)
            );
          },
          msg: translate('jp.verification.companyName.check'),
        },
      ],
    },

    // 企业名称(片假字)
    companyNamePy: {
      formType: FormType.TEXT,
      title: translate('jp.company.companyNamePy'),
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 50,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkJP(val);
          },
          msg: translate('jp.verif.pj.errormsg'),
        },
      ],
    },

    // 企业英文名称
    companyNameEn: {
      formType: FormType.TEXT,
      title: translate('jp.company.companyNameEn'),
      extend: 0,
      subTitle: translate('jp.verification.subtitle'),
      required: false,
      input: [
        {
          placeholder: '',
          maxLength: 50,
        },
      ],
    },

    // 业务类型
    businessType: {
      formType: FormType.MULTI_INPUT,
      title: translate('jp.verification.company.business.type'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          key: 'careerLvOne',
          formType: FormType.SELECT,
          type: 'text',
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 20,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 业务内容
    business: {
      formType: FormType.TEXT_AREA,
      title: translate('jp.verification.company.business.content'),
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 100,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 是否有企业号码
    haveCompanyNumber: {
      formType: FormType.RADIO,
      extend: 0,
      title: translate('jp.verification.company.haveCompanyNumber'),
      cleanValue: false,
      list: [
        {
          value: 1,
          label: translate('jp.company.bear.yes'),
        },
        {
          value: 0,
          label: translate('jp.company.bear.no'),
        },
      ],
      input: [
        {
          value: 1,
        },
      ],
    },

    // 请描述原因
    noNumberReason: {
      formType: FormType.TEXT_AREA,
      title: translate('jp.common.please.descrip.reason'),
      hidden: true,
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 50,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 企业号码
    companyNumber: {
      formType: FormType.TEXT,
      title: translate('jp.company.companyNumber'),
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 50,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkInt(val);
          },
          msg: translate('user.inter.check.number'),
        },
      ],
      rightArea: '',
    },

    // 企业属性
    officeType: {
      formType: FormType.RADIO,
      extend: 0,
      title: translate('jp.company.office.type'),
      cleanValue: false,
      list: [
        {
          value: 1,
          label: translate('jp.company.head.office'),
        },
        {
          value: 2,
          label: translate('jp.company.branch.office'),
        },
      ],
      input: [
        {
          value: 1,
        },
      ],
    },

    // 总公司注册国家
    registerCountry: {
      formType: FormType.SELECT,
      title: translate('jp.company.register.country'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 200,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 企业成立日期
    establishedDate: {
      formType: FormType.DATE,
      title: translate('jp.company.established.date'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 200,
          maxDate: new Date().getTime(),
        },
      ],
    },

    // 员工数
    employeeNumber: {
      formType: FormType.SELECT,
      title: translate('jp.company.employee.number'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 200,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
      list: [
        {
          value: 1,
          label: translate('jp.company.employee.number.option1'),
        },
        {
          value: 2,
          label: translate('jp.company.employee.number.option2'),
        },
        {
          value: 3,
          label: translate('jp.company.employee.number.option3'),
        },
        {
          value: 4,
          label: translate('jp.company.employee.number.option4'),
        },
        {
          value: 5,
          label: translate('jp.company.employee.number.option5'),
        },
        {
          value: 6,
          label: translate('jp.company.employee.number.option6'),
        },
      ],
    },

    // 年收入
    income: {
      formType: FormType.SELECT,
      title: translate('jp.verification.enterpriseincome'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 200,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
      list: [
        {
          value: 1,
          label: translate('jp.verification.enterpriseincome.option1'),
        },
        {
          value: 2,
          label: translate('jp.verification.enterpriseincome.option2'),
        },
        {
          value: 3,
          label: translate('jp.verification.enterpriseincome.option3'),
        },
        {
          value: 4,
          label: translate('jp.verification.enterpriseincome.option4'),
        },
        {
          value: 5,
          label: translate('jp.verification.enterpriseincome.option5'),
        },
        {
          value: 6,
          label: translate('jp.verification.enterpriseincome.option6'),
        },
      ],
    },

    // 注册资本
    registerCapital: {
      formType: FormType.NUMBER,
      noWheelEvent: true,
      title: translate('jp.comp.registerCapital'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 20,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    liability: {
      formType: FormType.NUMBER,
      noWheelEvent: true,
      title: translate('jp.comp.liability'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 20,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // URL
    siteUrl: {
      formType: FormType.TEXT,
      title: translate('jp.comp.siteUrl'),
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 200,
        },
      ],
    },

    // 企业所在国
    residence: {
      formType: FormType.RADIO,
      cleanValue: false,
      title: translate('jp.comp.residence'),
      extend: 0,
      list: [
        {
          id: 1,
          value: 1,
          label: translate('jp.verification.japan'),
        },
      ],
      input: [
        {
          value: 1,
        },
      ],
      bottomTips: [translate('jp.verification.residence.company.tips')],
    },
    // 邮编
    postCode: {
      formType: FormType.NUMBER,
      noWheelEvent: true,
      title: translate('jp.company.postCode'),
      cleanValue: false,
      extend: 0,
      bottomTips: [translate('jp.company.postCode.tips')],
      input: [
        {
          placeholder: '',
          maxLength: 20,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkJpPostcode(val);
          },
          msg: translate('jp.verification.number.seven'),
        },
      ],
    },

    // 企业地址
    address: {
      formType: FormType.MULTI_INPUT,
      title: translate('kyc.address.title'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          key: 'province',
          formType: FormType.TEXT,
          type: 'text',
          value: '',
          placeholder: '',
          maxLength: 20,
          disabled: true,
        },
        {
          key: 'city',
          formType: FormType.TEXT,
          type: 'text',
          placeholder: '',
          value: '',
          maxLength: 20,
          disabled: true,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 企业担当者地址
    directorAddress: {
      formType: FormType.MULTI_INPUT,
      title: translate('kyc.address.title'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          key: 'directorprovince',
          formType: FormType.TEXT,
          type: 'text',
          value: '',
          placeholder: '',
          maxLength: 20,
          disabled: true,
        },
        {
          key: 'directorcity',
          formType: FormType.TEXT,
          type: 'text',
          placeholder: '',
          value: '',
          maxLength: 20,
          disabled: true,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 企业法人地址
    legalAddress: {
      formType: FormType.MULTI_INPUT,
      title: translate('kyc.address.title'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          key: 'legalprovince',
          formType: FormType.TEXT,
          type: 'text',
          value: '',
          placeholder: '',
          maxLength: 20,
          disabled: true,
        },
        {
          key: 'legalcity',
          formType: FormType.TEXT,
          type: 'text',
          placeholder: '',
          value: '',
          maxLength: 20,
          disabled: true,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 街道 / 住所入力欄の「町村」にあたる部分（選択式）
    street: {
      formType: FormType.TEXT,
      title: translate('kyc.street.title'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          textCreator: translate('user.operation.createOption'),
          placeholder: translate('kyc.street.example'),
          maxLength: 50,
        },
      ],
    },

    // 地址 / 住所入力欄の「番地・建物・部屋番号（全角）」にあたる部分
    location: {
      formType: FormType.TEXT,
      title: translate('kyc.detail.title'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          maxLength: 500,
          placeholder: translate('kyc.location.example'),
        },
      ],
    },

    // 企业号码
    companyPhone: {
      formType: FormType.TEXT,
      title: translate('jp.company.companyPhone'),
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 20,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkInt(val);
          },
          msg: translate('user.inter.check.number'),
        },
      ],
    },

    // 法人代表 中文
    legalFirstName: {
      formType: FormType.MULTI_INPUT,
      extend: 0,
      title: translate('jp.company.name'),
      cleanValue: false,
      input: [
        {
          key: 'legallastName',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderLeft: translate('jp.verification.firstName'),
          maxLength: 20,
        },
        {
          key: 'legalfirstName',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderLeft: translate('jp.verification.lastName'),
          maxLength: 20,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 法人代表 拼音
    legalFirstNamePy: {
      formType: FormType.MULTI_INPUT,
      extend: 0,
      title: translate('jp.company.namePy'),
      cleanValue: false,
      input: [
        {
          key: 'legallastNamePy',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderLeft: translate('jp.verification.firstName'),
          maxLength: 20,
        },
        {
          key: 'legalfirstNamePy',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderLeft: translate('jp.verification.lastName'),
          maxLength: 20,
        },
      ],
      bottomTips: [translate('jp.verification.lastName.katakana.tips')],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 法人代表 英文
    legalFirstNameEn: {
      formType: FormType.MULTI_INPUT,
      extend: 0,
      title: translate('jp.company.nameEn'),
      cleanValue: false,
      subTitle: translate('jp.verification.subtitle'),
      required: false,
      input: [
        {
          key: 'legallastNameEn',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderLeft: translate('jp.verification.firstName'),
          maxLength: 20,
        },
        {
          key: 'legalfirstNameEn',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderLeft: translate('jp.verification.lastName'),
          maxLength: 20,
        },
      ],
    },

    isDirectorSameLegal: {
      formType: FormType.RADIO,
      title: translate('jp.comp.director.same.legal'),
      cleanValue: false,
      list: [
        {
          value: 1,
          label: translate('jp.company.yes'),
        },
        {
          value: 0,
          label: translate('jp.company.no'),
        },
      ],
      input: [{}],
    },

    // 是上市企业、国家、地方公共体、独立行政机关等组织吗？
    isAdminOrganization: {
      formType: FormType.RADIO,
      extend: 0,
      title: translate('jp.comp.share.isOrgan'),
      cleanValue: false,
      list: [
        {
          value: 1,
          label: translate('jp.company.yes'),
        },
        {
          value: 0,
          label: translate('jp.company.no'),
        },
      ],
      input: [{}],
    },

    isExistShare: {
      formType: FormType.RADIO,
      title: translate('jp.comp.share.isExist'),
      cleanValue: false,
      list: [
        {
          value: 1,
          label: translate('jp.company.yes'),
        },
        {
          value: 0,
          label: translate('jp.company.no'),
        },
      ],
      input: [{}],
    },

    // 是否有4人股东
    isOverFourShare: {
      formType: FormType.RADIO,
      extend: 0,
      title: translate('jp.comp.over.four.share'),
      subTitle: translate('jp.comp.have.four.share.tips'),
      cleanValue: false,
      hidden: true,
      list: [
        {
          value: 1,
          label: translate('jp.company.bear.yes'),
        },
        {
          value: 0,
          label: translate('jp.company.bear.no'),
        },
      ],
      input: [{}],
    },

    // 是否有实际股东
    haveActualShareholder: {
      formType: FormType.RADIO,
      extend: 0,
      title: translate('jp.company.actual.share'),
      cleanValue: false,
      list: [
        {
          value: 1,
          label: translate('jp.company.bear.yes'),
        },
        {
          value: 0,
          label: translate('jp.company.bear.no'),
        },
      ],
      input: [{}],
    },

    // 是否有政府股东
    haveGovernmentShareholder: {
      formType: FormType.RADIO,
      extend: 0,
      title: translate('jp.company.gov.share'),
      cleanValue: false,
      list: [
        {
          value: 1,
          label: translate('jp.company.bear.yes'),
        },
        {
          value: 0,
          label: translate('jp.company.bear.no'),
        },
      ],
      input: [{}],
    },

    // 政府股东持有率
    governmentHoldRate: {
      formType: FormType.RADIO,
      extend: 0,
      title: translate('jp.company.gov.hold.rate'),
      cleanValue: false,
      hidden: true,
      list: [
        {
          value: 1,
          label: translate('jp.common.greater.than.fifty'),
        },
        {
          value: 2,
          label: translate('jp.common.less.than.fifty'),
        },
      ],
      input: [{}],
    },

    // 担当理由
    tenureReason: {
      formType: FormType.SELECT,
      title: translate('jp.company.director.reason'),
      cleanValue: false,
      hidden: true,
      extend: 0,
      input: [
        {
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 20,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
      list: [
        {
          value: 1,
          label: translate('jp.company.director.reason.option1'),
        },
        {
          value: 2,
          label: translate('jp.company.director.reason.option2'),
        },
      ],
    },

    // 部门及负责内容
    directordepartment: {
      formType: FormType.TEXT,
      title: translate('jp.company.depa.responsible'),
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 50,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 股东
    shareholders: {
      formType: FormType.CARD,
      title: translate('jp.comp.actual.share'),
      hidden: true,
      extend: 0,
      input: [{}],
      listValue: [],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 法人两个姓名
    legalfirstName: {
      formType: FormType.MULTI_INPUT,
      extend: 0,
      title: translate('jp.verification.name'),
      cleanValue: false,
      input: [
        {
          key: 'legallastName',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderRight: translate('jp.verification.firstName'),
          maxLength: 20,
        },
        {
          key: 'legalfirstName',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderRight: translate('jp.verification.lastName'),
          maxLength: 20,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkJpName(val) && !checkEnName(val);
          },
          msg: translate('jp.verification.name.check'),
        },
      ],
      bottomTips: [translate('jp.verification.name.tips')],
    },

    // 姓名 片假字
    legalfirstNamePy: {
      formType: FormType.MULTI_INPUT,
      title: translate('jp.verification.namePy'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          key: 'legallastNamePy',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderRight: translate('jp.verification.firstName.katakana'),
          maxLength: 20,
        },
        {
          key: 'legalfirstNamePy',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderRight: translate('jp.verification.lastName.katakana'),
          maxLength: 20,
        },
      ],
      bottomTips: [translate('jp.verification.lastName.katakana.tips')],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkJP(val);
          },
          msg: translate('jp.verif.pj.errormsg'),
        },
      ],
    },

    // 担当者两个姓名
    directorfirstName: {
      formType: FormType.MULTI_INPUT,
      extend: 0,
      title: translate('jp.verification.name'),
      cleanValue: false,
      input: [
        {
          key: 'directorlastName',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderRight: translate('jp.verification.firstName'),
          maxLength: 20,
        },
        {
          key: 'directorfirstName',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderRight: translate('jp.verification.lastName'),
          maxLength: 20,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkJpName(val) && !checkEnName(val);
          },
          msg: translate('jp.verification.name.check'),
        },
      ],
      bottomTips: [translate('jp.verification.name.tips')],
    },

    // 姓名 片假字
    directorfirstNamePy: {
      formType: FormType.MULTI_INPUT,
      title: translate('jp.verification.namePy'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          key: 'directorlastNamePy',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderRight: translate('jp.verification.firstName.katakana'),
          maxLength: 20,
        },
        {
          key: 'directorfirstNamePy',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderRight: translate('jp.verification.lastName.katakana'),
          maxLength: 20,
        },
      ],
      bottomTips: [translate('jp.verification.lastName.katakana.tips')],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkJP(val);
          },
          msg: translate('jp.verif.pj.errormsg'),
        },
      ],
    },
  };
  return template;
}

export default getBase;
